<template>
	<main>
		<section id="form">
            <div id="form-photo" class="internal">
			</div>
			<div id="form-content">
                <div class="container mb-5 flex-grow">
                    <Logo outerClass="py-4 pt-sm-5 pb-sm-3" color="_dark" innerClass="logo" type="png" />
                    <router-view />
                </div>

                <Footer />

			</div>
			
		</section>
	</main>
</template>

<script>
// @ is an alias to /src
import Logo from '@/components/Logo.vue';
import Footer from '@/components/Footer.vue';
import RouterView from 'vue-router';

export default {
  name: 'Legal',
  components: {
    Logo,
    Footer,
  }
}
</script>



